import { render, staticRenderFns } from "./ConfigurationWorkspacePolicy.vue?vue&type=template&id=2fe43d68&"
import script from "./ConfigurationWorkspacePolicy.vue?vue&type=script&lang=js&"
export * from "./ConfigurationWorkspacePolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCard,VDataTable,VSelect})
